import { controls,grouped } from "../controls";
const talathi_approvals = {
label: "Talathi Approvals",
pageLabel: "Talathi Approvals",starting: true,url: "autogen",
formActions: { edit: { allow: true },delete:{allow:false} },
pageType: "history",
filter:[
]
,form:[
...controls.displayText({ tab: "general", label: "Acceptance Status",star:false}),
...controls.autoComplete({tab: "general", name: "acceptance_status_code", width: "col-sm-2",controlType: "AcceptanceStatus"}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Talathi Approval Remark",star:false,parents:[{"name": "talathi_approval.acceptance_status_code", "match": "in", "value": ["accept"]}]}),
...controls.text({ tab: "general",  placeHolder: "", name: "talathi_approval_remark",width:"col-sm-4",maxlength:200,parents:[{"name": "talathi_approval.acceptance_status_code", "match": "in", "value": ["accept"]}],isRequired:true}),
...controls.displayText({ tab: "general", label: "Rejection Remark",star:false,parents:[{"name": "talathi_approval.acceptance_status_code", "match": "in", "value": ["reject"]}]}),
...controls.text({ tab: "general",  placeHolder: "", name: "rejection_remark",width:"col-sm-4",maxlength:200,parents:[{"name": "talathi_approval.acceptance_status_code", "match": "in", "value": ["reject"]}],isRequired:true}),
]
,history:{
perPage: 10,
reportHeader: "Talathi Approvals",
pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
clickable: true,
displayColumns: [
{Header: "Sr",type: "autoinc",accessor: "srno",align: "center",width: 30},
]}};
export default talathi_approvals;